import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddressBookSearchParams } from './address-book-params.interface';
import { Observable } from 'rxjs';
import { AddressBookResponse } from './model/address-book.model';
import { PaginatedData } from '../shared/models/table';

@Injectable({
  providedIn: 'root'
})
export class AddressBookService {
  constructor(private http: HttpClient) {}

  getContacts(payload: AddressBookSearchParams): Observable<PaginatedData<AddressBookResponse>> {
    return this.http.post<PaginatedData<AddressBookResponse>>('/address-book', payload);
  }
}
